document.addEventListener('DOMContentLoaded', function () {

  /* FEATURE SLIDER (unchanged) */
  const swiper = new Swiper('.feature-collection-slider .swiper', {
    effect: 'slide',
    loop: true,
    centeredSlides: true,
    slidesPerView: 'auto',
    spaceBetween: 40,
    grabCursor: true,
    slideToClickedSlide: true,
    pagination: {
      el: '.feature-collection-slider .swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      320: { slidesPerView: 1.5, spaceBetween: 20 },
      768: { slidesPerView: 3, spaceBetween: 40 },
      1024:{ slidesPerView: 5, spaceBetween: 50 }
    }
  });

/* REVIEW SLIDER (separate instance, no variable reuse) */
const reviewSwiper = new Swiper('.reviewSwiper', {
  effect: 'slide',
  slidesPerView: 'auto',      // default for desktop
  spaceBetween: 20,            // default gap
  resistance: true,         
  resistanceRatio: 0,         
  slideToClickedSlide: true,
  loop: false,              
  watchOverflow: true,      
  pagination: {
    el: '.reviewSwiper .swiper-pagination',
    clickable: true,
  },
  navigation: {
    nextEl: '.reviewSwiper .swiper-button-next',
    prevEl: '.reviewSwiper .swiper-button-prev',
  },
  breakpoints: {
    // when window width is <= 768px (mobile)
    0: {
      slidesPerView: 1.3,  // show 1 full slide + peek of next
      spaceBetween: 15,    // adjust gap for mobile if needed
    },
    // optional: tablet
    768: {
      slidesPerView: 'auto',
      spaceBetween: 20,
    }
  }
});





});


  // Scroll Slider
  const container = document.querySelector(".product-lsit-blocks-content");

let isDown = false;
let startX;
let scrollLeft;

container.addEventListener("mousedown", (e) => {
  isDown = true;
  startX = e.pageX - container.offsetLeft;
  scrollLeft = container.scrollLeft;
});

container.addEventListener("mouseleave", () => (isDown = false));
container.addEventListener("mouseup", () => (isDown = false));

container.addEventListener("mousemove", (e) => {
  if (!isDown) return;
  e.preventDefault();
  const x = e.pageX - container.offsetLeft;
  container.scrollLeft = scrollLeft - (x - startX) * 2;
});


// 
document.addEventListener("DOMContentLoaded", () => {
    const timelineLine = document.querySelector(".gr-timeline::before"); // pseudo-element सीधे select नहीं होता
    const timeline = document.querySelector(".gr-timeline");

    if (!timeline) return;

    // Workaround: pseudo-element को style tag में dynamic CSS देना होगा
    // हम dynamically <style> tag add करेंगे
    const styleTag = document.createElement("style");
    document.head.appendChild(styleTag);

    // Set a unique class for timeline for JS reference
    const timelineId = "dynamic-timeline-line";
    timeline.classList.add(timelineId);

    function updateLineHeight() {
        const scrollY = window.scrollY;
        const timelineRect = timeline.getBoundingClientRect();
        const windowHeight = window.innerHeight;

        // Start from top of timeline
        const start = timelineRect.top + scrollY;
        // End at bottom of viewport or timeline bottom
        const end = scrollY + windowHeight;
        const timelineHeight = timelineRect.height;

        // Calculate progress: 0 → 1
        let progress = (scrollY + windowHeight/2 - start) / timelineHeight;
        progress = Math.max(0, Math.min(1, progress));

        const newHeight = progress * timelineHeight;

        // Update pseudo-element height via CSS
        styleTag.innerHTML = `
            .${timelineId}::before {
                height: ${newHeight}px;
            }
        `;
    }

    window.addEventListener("scroll", () => requestAnimationFrame(updateLineHeight));
    updateLineHeight();
});
// 
// document.addEventListener('scroll', () => {
//   const scrollY = window.scrollY;
//   const triggerPoint = 300; // 200px

//   if (scrollY >= triggerPoint) {
//     document.body.classList.add('scrolled-200px');
//   } else {
//     document.body.classList.remove('scrolled-200px');
//   }
// });



document.addEventListener('scroll', () => {
  const scrollY = window.scrollY;
   const triggerPoint = window.innerHeight - 200;
  if (scrollY >= triggerPoint) {
    document.body.classList.add('scrolled-200px');
  } else {
    document.body.classList.remove('scrolled-200px');
  }
});
